import { ref } from 'vue';
import { useLocale } from './useLocale';

import { get, post } from '@/api/httpClient';
import type { NewQuoteInfo } from '@/typings/quotes/NewQuotesInfo';
import type { GetUnitQuoteRequest } from '@/typings/requests/GetUnitQuoteRequest';
import type { SendQuoteInfoInquiryRequest } from '@/typings/requests/SendQuoteInfoInquiry';

export function useUnitsQuoteApi() {
  const { getLocale } = useLocale();
  const getUnitQuoteByIdError = ref<string | undefined>();
  const getUnitQuoteByIdLoading = ref(false);
  const sendQuoteInfoInquiryError = ref<string | undefined>();
  const sendQuoteInfoInquiryLoading = ref(false);

  async function getUnitQuoteById(id: number, request: GetUnitQuoteRequest): Promise<NewQuoteInfo> {
    getUnitQuoteByIdLoading.value = true;
    try {
      const lang = getLocale();
      return await get<any, NewQuoteInfo>(`/quotes/newQuoteInfo/${id}`, { ...(request as any), locale: lang });
    } catch (err) {
      getUnitQuoteByIdError.value = err instanceof Error ? err.message : 'Unknown error';
      throw err;
    } finally {
      getUnitQuoteByIdLoading.value = false;
    }
  }

  async function sendQuoteInfoInquiry(request: SendQuoteInfoInquiryRequest): Promise<void> {
    sendQuoteInfoInquiryLoading.value = true;

    try {
      const lang = getLocale();

      await post<SendQuoteInfoInquiryRequest, void>(
        `/form/unit?locale=${lang}`,
        request
      );
    } catch (err) {
      console.error('Erreur lors de l\'envoi:', err);
      sendQuoteInfoInquiryError.value = err instanceof Error ? err.message : 'Unknown error';
      throw err;
    } finally {
      sendQuoteInfoInquiryLoading.value = false;
    }
  }

  return {
    getUnitQuoteById,
    getUnitQuoteByIdError,
    getUnitQuoteByIdLoading,
    sendQuoteInfoInquiry,
    sendQuoteInfoInquiryError,
    sendQuoteInfoInquiryLoading
  };
}
